module.exports = __webpack_public_path__ + "961bb9da.svg";